/**
 * 预热底栏 / 中间快捷菜单静态图，避免进页 API 占满连接时图标空白。
 * H5：Image() 拉取进缓存；其它端忽略。
 */
const CHROME_IMAGES = [
  '/static/image/lanhu/tabbar/ai-fab.webp',
  '/static/image/lanhu/tabbar/home.webp',
  '/static/image/lanhu/tabbar/trade.webp',
  '/static/image/lanhu/tabbar/fund.webp',
  '/static/image/lanhu/tabbar/assets.webp',
  '/static/image/tabbar/bg.webp',
  '/static/image/tabbar/t_ai.webp',
  '/static/image/tabbar/t_contract.webp',
  '/static/image/tabbar/t_jiedian.webp',
] as const;

let warmed = false;

export function preloadChromeImages(force = false): void {
  if (warmed && !force) return;
  warmed = true;
  if (typeof Image === 'undefined') return;
  for (const src of CHROME_IMAGES) {
    try {
      const img = new Image();
      img.decoding = 'async';
      // 提高相对晚到 XHR 的优先级（支持的浏览器）
      try {
        (img as HTMLImageElement & { fetchPriority?: string }).fetchPriority = 'high';
      } catch {
        /* ignore */
      }
      img.src = src;
    } catch {
      /* ignore */
    }
  }
}
